// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPopup_container__kVGRx","errIcon":"ErrorPopup_errIcon__3UiFW"};